const form = document.querySelector('.js-payment-form');

export function init() {
	if (form) {
		form.addEventListener('change', event => {
			if (event.target.name !== 'billingAddressSameAsShipping') {
				return;
			}

			const addressFields = form.querySelector('.js-address-fields');
			const sameAsShippingInputs = Array.from(form.querySelectorAll('[name="billingAddressSameAsShipping"]'));

			const checkedOption = sameAsShippingInputs.filter(input => input.checked === true);

			addressFields.classList.toggle('active', checkedOption.value);
		});
	}
}
